import React, { PropsWithChildren } from "react"

import Box from "@mui/material/Box"
import CircularProgress from "@mui/material/CircularProgress"

import { useTranslations } from "@cirrus/core/i18n"

export const TranslationsGuard = ({ children }: PropsWithChildren) => {
  const { translations, error, loading } = useTranslations()

  if (error) return null
  if (loading && !translations) return <PagePreloader />

  return <>{children}</>
}

const PagePreloader = () => <Box sx={{
  height: "100vh",
  display: "flex",
  placeItems: "center",
  placeContent: "center"
}}>
  <CircularProgress />
</Box>
